/**
 * Main Application Entry Point
 * Orchestrates vendor libraries for Dropsite
 */

// Import vendor setup
import { htmx } from './vendor/htmx.js';
import { initCommon } from '../components/common_fragment.js';
import { initUploadFragment } from './upload_fragment.js';
import { initPortalSendFragment } from './portal_send_fragment.js';
import { initPortalExplorer } from '../pages/drop/portal/explorer/portal_explorer_fragment.js';
import { initPortalInbox } from '../pages/drop/portal/downloads/portal_inbox_fragment.js';
import { initGuestValidate } from '../pages/drop/guest/validate/validate_fragment.js';
import { initChat } from '../pages/drop/chat/chat_fragment.js';

// ============================================================================
// Application Initialization
// ============================================================================

document.addEventListener('DOMContentLoaded', () => {
    console.log('[Dropsite] Bundle loaded');
    // Turnstile widgets, timezone inputs and the navigation/field shortcuts
    // appear across every flow, so common behaviors wire up first.
    initCommon();
    // Each module looks for its own form element (#secure-upload-content for
    // the external flow, #portal-send-content for the in-portal flow) and
    // no-ops if absent — only the active flow wires up handlers on the
    // current page.
    initUploadFragment();
    initPortalSendFragment();
    initPortalExplorer();
    initPortalInbox();
    initGuestValidate();
    // initChat is idempotent and wires document-level htmx event listeners
    // that activate the captcha widget when the panel is swapped in.
    initChat();
});

// Export for external access if needed
export { htmx };
